var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #001109;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.23,1.37l15.4,15.36c.31.31.82.31,1.13,0s.31-.82,0-1.13L1.37.23c-.31-.31-.82-.31-1.13,0S-.08,1.05.23,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.77.23c-.31-.31-.82-.31-1.13,0L.23,15.59c-.31.31-.31.82,0,1.13s.82.31,1.13,0L16.77,1.37c.31-.31.31-.82,0-1.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbutton);
export default __webpack_public_path__ + "static/media/xbutton.07183466f66368909ad1802bd7d6c56f.svg";
export { ForwardRef as ReactComponent };